import { Modal, Select, Form } from "antd";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { ApiService, Hazard } from "../../api";
import { debounce } from "lodash";

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  handleAddHazard: (hazard: Hazard) => void;
}

const AddHazardModal = ({ visible, setVisible, handleAddHazard }: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [hazards, setHazards] = useState<Hazard[]>([]);

  useEffect(() => {
    loadHazards();
  }, [visible]);

  const loadHazards = async () => {
    const result = await ApiService.apiAssessmentLastFiveHazardsList();
    setHazards(result);
  };

  const handleSearchHazards = async (value: string) => {
    const result = await ApiService.apiAssessmentGetHazardsByQueryList(value);
    setHazards(result.slice(0, 10));
  };

  const handleSubmit = (values: any) => {
    const hazard = hazards.find((x) => x.id === values.hazard);
    hazard && handleAddHazard(hazard);
    form.resetFields();
    setVisible(false);
  };

  return (
    <Modal
      onOk={() => form.submit()}
      onCancel={() => setVisible(false)}
      open={visible}
      title={t("Add hazard")}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="hazard"
          label={t("Hazard")}
          rules={[
            {
              required: true,
              message: t("Please choose the hazard."),
            },
          ]}
        >
          <Select
            placeholder={t("Choose hazard..")}
            showSearch
            optionFilterProp="children"
            onSearch={debounce(handleSearchHazards, 300)}
          >
            {hazards.map((x) => (
              <Select.Option value={x.id}>{x.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddHazardModal;
